module.exports = __webpack_public_path__ + "static/media/dhara.e6c7b385.png";